import { render, staticRenderFns } from "./addxxpx.vue?vue&type=template&id=55c60b50&scoped=true&"
import script from "./addxxpx.vue?vue&type=script&lang=js&"
export * from "./addxxpx.vue?vue&type=script&lang=js&"
import style0 from "./addxxpx.vue?vue&type=style&index=0&id=55c60b50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c60b50",
  null
  
)

export default component.exports